"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSanitizedContentTitle = void 0;
/**
 * This function is used to get the sanitized content title
 * @param title - title of the content file
 * @param ext - extension of the content file
 */
var getSanitizedContentTitle = exports.getSanitizedContentTitle = function getSanitizedContentTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var CONTENT_TITLE_MAX_LENGTH = 16;
  var sanitizedTitle = title.replace(/.mp3|.wav|.mp4|media\//g, '');
  if ((sanitizedTitle === null || sanitizedTitle === void 0 ? void 0 : sanitizedTitle.length) > CONTENT_TITLE_MAX_LENGTH) {
    return "".concat(sanitizedTitle.substring(0, CONTENT_TITLE_MAX_LENGTH), "..").concat(ext);
  }
  return "".concat(sanitizedTitle).concat(ext);
};